import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { AuthPopupComponent } from '@app/modules/auth/modals/auth-popup/auth-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorage } from 'ngx-webstorage';

@Component({
  selector: 'ngx-auth',
  templateUrl: './auth.component.html',
  styleUrls: [
    './auth.style.scss',
  ],
})
export class AuthComponent implements OnInit, OnDestroy {
  @LocalStorage() token: string;

  subscription: any;
  authenticated: boolean = false;
  environment: any;
  showLoginForm: boolean = false;
  isResetPassword: boolean = false;

  constructor(
    private $modal: NgbModal,
    protected route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.environment = environment;
    this.route.queryParams.subscribe(params => {  
      if (environment?.name !== 'rcdss') {
        return;
      }
      if (params['isResetPassword'] === 'true' || this.router.url.toString().includes('/auth/reset-password')) {
        this.isResetPassword = true;
        this.showLoginFormHandler();
      }
    });
  }

  ngOnDestroy(): void {
  }

  showLoginFormHandler() {
    const activeModal = this.$modal.open(AuthPopupComponent, {
      size: 'md',
      container: 'nb-layout',
      windowClass: 'auth-modal',
    });
    activeModal.componentInstance.isResetPassword = this.isResetPassword;
    activeModal.result.then(() => {
      this.isResetPassword = false;
    });
  }
}
